import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { useEffect, useState } from 'react';
import Slider from 'react-slick';
import axios from 'axios';
import { Link } from 'react-router-dom';

const Galleries = () => {
  const [galleries, setGalleries] = useState([]);
  const [loading, setLoading] = useState(true);

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: true,
    pauseOnHover: true,
    swipe: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  useEffect(() => {
    loadGalleries();
  }, []);

  const loadGalleries = async () => {
    try {
      // const res = await axios.get(`${process.env.REACT_APP_API_PATH}galleries/public`);
      const res = await axios.get(`${process.env.REACT_APP_API_PATH}properties/public`,{
        params: {
          isGallery: true
        }
      });
      const { error, data } = res.data;

      if (!error && Array.isArray(data) && data.length > 0) {
        setGalleries(data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if(galleries.length < 1){
    return '';
  }

  return (
    <div style={{ maxWidth: '1100px', margin: 'auto', padding: '2rem' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '1rem' }}>Galleries</h2>

      {loading ? (
        <p style={{ textAlign: 'center' }}>Loading images...</p>
      ) : galleries.length === 0 ? (
        <p style={{ textAlign: 'center' }}>No gallery images found.</p>
      ) : (
        <>
          <style>
            {`
              .slick-prev:before,
              .slick-next:before {
                color: black !important;
                font-size: 30px !important;
                opacity: 1 !important;
              }

              .slick-prev,
              .slick-next {
                z-index: 10 !important;
                display: block !important;
              }

              .slick-track {
                display: flex !important;
              }

              .slick-slide {
                height: inherit !important;
                display: flex !important;
                justify-content: center;
              }

              .slick-slide > div {
                display: flex;
              }
            `}
          </style>

          <Slider {...settings}>
            {galleries.map((item, index) => (
              <div key={index} style={{ padding: '0 10px' }}>
                <Link to={`/properties/${item.slug}`}>
                  <img
                    // src={item.baseUrl + item.path}
                    src={item.rootImagePath + item.defaultImage}
                    alt={`Property ${index}`}
                    style={{
                      width: '100%',
                      height: '250px',
                      objectFit: 'cover',
                      borderRadius: '10px',
                      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                    }}
                  />
                </Link>
              </div>
            ))}
          </Slider>
        </>
      )}
    </div>
  );
};

export default Galleries;